<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :title="''"
      :visible="isShow"
      class="egl-dialog soldRate"
      :modal="false"
      :before-close="closeDialog"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
    <el-row>
      <el-col :span="18" id="print">
        <el-row type="flex" justify="space-between" :gutter="20">
          <el-col :span="16">
            <div class="house-link-box">
              <Seating
                v-bind:seatingPlan="seatObj.seatingPlan"
                v-bind:linesNumber="seatObj.seatingPlan.seats.length"
                v-bind:columnsNumber="seatObj.seatingPlan.seats[0].length"
                v-bind:pageSource="'list'"
              ></Seating>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="realtime-seatplan">
              <p>{{ $locale("nonArrivalTicketRecord.dialog.formField.upcomingDate") }}: {{ scheduleInfo.scheduleDate }}</p>
              <p>{{ $locale("global.works") }}: {{ scheduleInfo.movieName }}</p>
              <p>{{ $locale("schedule.movieShowTime") }}: {{ scheduleInfo.movieShowTime }}</p>
              <p>{{ $locale("schedule.version") }}: {{ scheduleInfo.version1 }}</p>
              <p>{{ $locale("global.subtitlesDubbing") }}: {{ scheduleInfo.version2 }}</p>
              <p>{{ $locale("global.otherVersions") }}: {{ scheduleInfo.version3 }}</p>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="ta-r" style="margin-top: -40px;">
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Seating from "@/components/Theatre/Seating.vue";
import { getSimpleMovieList, getVersion, getOtherVersion } from '@/helpers/service/api/common';
import { getShceduleDetail, getSoldSeat, getHouseDetail } from "@/helpers/service/api/schedule.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { subTitleMap } from "@/utils/common";

export default {
  name: "SoldSeatDialog",
  data() {
    return {
      isShow: false,
      seatObj: {
        seatingPlan: {
          seats: [[]],
        }
      },
      printObj: {
        popTitle: 'RealTime SeatPlan',
        id: "print",
      },
      scheduleInfo: {},
    };
  },
  methods: {
    closeDialog() {
      this.isShow = false;
    },
    getOtherVersionNames(ids, version3List) {
      if (!version3List || version3List.length === 0 || !ids || ids.length === 0) return '';
      const _arr = []
      version3List.forEach((item) => {
        ids.forEach((id) => {
          if (item.id === id) {
            _arr.push(item.name);
          }
        })
      })
      return _arr.join(', ');
    },
    showDialog(id, movieId) {
      const that = this;
      getShceduleDetail({id}).then(schedule => {
        let houseId = schedule.data.houseId;
        requestAll([
          getHouseDetail(houseId),
          getSoldSeat(id),
          getSimpleMovieList({
            approve: true,
            page: 0,
            pageSize: 99999,
            hiddenCms: false,
            ids: [],
            cinemaId: window.localStorage.getItem("cinemaId"),
            field: ['id', 'name']
          }),
          getVersion({
            page: 0,
            pageSize: 99999,
            cinemaId: window.localStorage.getItem("cinemaId")
          }),
          getOtherVersion({ cinemaId: window.localStorage.getItem("cinemaId"), page: 0, pageSize: 99999 }),
          ]).then(res => {
          let seatObj = {
            seatingPlan: res[0].data.seatingPlan,
          };
          // mapping movieName
          // mapping Version1
          // mapping Version2
          // mapping Version3
          this.scheduleInfo = {
            scheduleDate: this.$moment(schedule.data.startTime).format('YYYY-MM-DD'),
            movieName: (res[2].data.data.find((item) => item.id === movieId) || {}).name,
            movieShowTime: this.$moment(schedule.data.startTime).format('HH:mm'),
            version1: (res[3].data.data.find((item) => item.id === schedule.data.version) || {}).name,
            version2: subTitleMap[schedule.data.subtitlesVersion],
            version3: this.getOtherVersionNames(schedule.data.otherVersion, res[4].data.data),
          };
          const row = seatObj.seatingPlan.seats.length;
          // const column = seatObj.seatingPlan.seats[0].length;

          if (schedule.data) {
            const { houseCover: { showSeatTypes }} = schedule.data
            if (showSeatTypes && showSeatTypes.length > 0) {
              showSeatTypes.forEach(item => {
                for (let i = 0; i < row; i++) {
                  const column = seatObj.seatingPlan.seats[i].length
                  for (let j = 0; j < column; j++) {
                    if (item.sid == seatObj.seatingPlan.seats[i][j].sid) {
                      seatObj.seatingPlan.seats[i][j].seatStatus = item.seatStatus;
                      break;
                    }
                  }
                }
              })
            }
          }
          res[1].data.showSeatTypes.map(item => {
            for (let i = 0; i < row; i++) {
              const column = seatObj.seatingPlan.seats[i].length
              for (let j = 0; j < column; j++) {
                if (item.sid == seatObj.seatingPlan.seats[i][j].sid) {
                  seatObj.seatingPlan.seats[i][j].seatStatus = item.seatStatus;
                  break;
                }
              }
            }
          });

          that.seatObj = seatObj;
          that.isShow = true;
        });
      }).catch(err => {});
    },
  },
  mounted() {},
  watch: {
    isShow() {
    },
  },
  components: {
    Seating,
  },
};
</script>
<style lang="scss">
  .soldRate .el-dialog {
    width: 80% !important;
  }
  .realtime-seatplan p {
    width: 300px;
    margin-top: 0;
    // margin-left: 30px;
  }
</style>